@if (hasShow()) {
  <div class="mt-0 mb-2">
    Played on <span class="italic">{{ showName() }}</span>
    {{hostConjunction}} <span class="italic">{{ hostName() }}</span>
    {{dateConjunction}} <span class="italic">{{ broadcastedAt() }}</span>
  </div>
}

<div class="large-image-container text-center">
  <img [src]="npImageUrl()" alt="" aria-label="" [title]="npImageLabel()" class="max-w-80 max-h-80 ml-auto mr-auto"/>
</div>

@let ci = content();
@if (ci) {
  <div class="mt-2 md:mt-3">
    <kexp-full-track-info [content]="ci"></kexp-full-track-info>
  </div>
  <div class="comment mt-2 md:mt-3">

    <div class="text-sm">
      <hng-safe-html [htmlString]="ci.comment"></hng-safe-html>
    </div>
  </div>
}
